import { render, staticRenderFns } from "./TeamRosterV2.vue?vue&type=template&id=071dd9dc&"
import script from "./TeamRosterV2.vue?vue&type=script&lang=ts&"
export * from "./TeamRosterV2.vue?vue&type=script&lang=ts&"
import style0 from "./TeamRosterV2.vue?vue&type=style&index=0&id=071dd9dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports